import { useAddressCountryData } from "@hooks/queries"
import { useMemo } from "react"

export function useAddressConfig() {
  const countryData = useAddressCountryData(undefined)
  const data = countryData?.data?.countryData

  const countries = useMemo(() => {
    if (!data) return []
    return Object.entries(countryData?.data?.countryData).map(([key, value]: any) => ({
      allowBilling: value.allowBilling as boolean,
      allowShipping: value.allowShipping as boolean,
      states: Object.entries(value.states).map(([key, value]: any) => ({
        label: value as string,
        value: key as string,
      })),
      locale: value.locale as Record<
        "postcode" | "city" | "state",
        | {
            label?: string
            required?: boolean
            hidden?: boolean
          }
        | undefined
      >,
      value: key,
      label: value.name as string,
    }))
  }, [data])

  return {
    countries,
  }
}
